<ng-template #appStore>
  <mobile-badge-item
    [imgSrc]="stores.AppStore | badgeUrl"
    (badgeClick)="onMarketClick(stores.AppStore)" />
</ng-template>

<ng-template #googlePlay>
  <mobile-badge-item
    [imgSrc]="stores.GooglePlay | badgeUrl"
    (badgeClick)="onMarketClick(stores.GooglePlay)" />
</ng-template>

<ng-template #apk>
  <mobile-badge-item
    [imgSrc]="stores.Apk | badgeUrl"
    (badgeClick)="onMarketClick(stores.Apk)" />
</ng-template>

<ng-template #appGallery>
  <mobile-badge-item
    [imgSrc]="stores.AppGallery | badgeUrl"
    (badgeClick)="onMarketClick(stores.AppGallery)" />
</ng-template>

<ng-template #galaxyStore>
  <mobile-badge-item
    [imgSrc]="stores.GalaxyStore | badgeUrl"
    (badgeClick)="onMarketClick(stores.GalaxyStore)" />
</ng-template>

<ng-template #getApps>
  <mobile-badge-item
    [imgSrc]="stores.GetApps | badgeUrl"
    (badgeClick)="onMarketClick(stores.GetApps)" />
</ng-template>

<ng-template #ruStore>
  <mobile-badge-item
    [imgSrc]="stores.RuStore | badgeUrl"
    (badgeClick)="onMarketClick(stores.RuStore)" />
</ng-template>

@if (os === 'Desktop') {
  <div class="app-links app-links_desktop">
    <div class="app-links__desc lg-hidden">
      <!-- prettier-ignore-attribute i18n -->
      <span
        class="app-links__text"
        i18n="Заголовок в ссылках на мобильные приложения@@track-map/mobile-app/app-links-text"
        >Пользуйся приложением</span
      >
      <strong class="app-links__app-name"> «{{ appName }}»</strong>
    </div>
    <div class="app-links__links">
      @if (storeUrls.googlePlay) {
        <ng-container *ngTemplateOutlet="googlePlay" />
      }
      @if (storeUrls.apk) {
        <ng-container *ngTemplateOutlet="apk" />
      }
      @if (storeUrls.appStore) {
        <ng-container *ngTemplateOutlet="appStore" />
      }
      @if (storeUrls.galaxyStore) {
        <ng-container *ngTemplateOutlet="galaxyStore" />
      }
      @if (storeUrls.getApps) {
        <ng-container *ngTemplateOutlet="getApps" />
      }
      @if (storeUrls.appGallery) {
        <ng-container *ngTemplateOutlet="appGallery" />
      }
      @if (storeUrls.ruStore) {
        <ng-container *ngTemplateOutlet="ruStore" />
      }
    </div>
  </div>
} @else {
  <div class="app-links app-links_mobile">
    @if (os === platforms.iOs && storeUrls.appStore) {
      <ng-container *ngTemplateOutlet="appStore" />
    }

    @if (os === platforms.Android) {
      @if (storeUrls.apk) {
        <ng-container *ngTemplateOutlet="apk" />
      }
      @if (storeUrls.ruStore) {
        <ng-container *ngTemplateOutlet="ruStore" />
      }
      @switch (vendor) {
        @case (storeUrls.galaxyStore ? vendors.Samsung : false) {
          <ng-container *ngTemplateOutlet="galaxyStore" />
        }
        @case (storeUrls.getApps ? vendors.Xiaomi : false) {
          <ng-container *ngTemplateOutlet="getApps" />
        }
        @case (storeUrls.getApps ? vendors.Xiaomi : false) {
          *ngSwitchCase="storeUrls?.appGallery ? vendors.Huawei : false">
          <ng-container *ngTemplateOutlet="appGallery" />
        }

        @default {
          <ng-container *ngTemplateOutlet="googlePlay" />
        }
      }
    }
  </div>
}
